import useSWR from "swr";
import HomepageCategoriesService from "services/HomepageCategoriesService";
import useDealerId from "hooks/useDealerId";

/**
 * useHomepageCategoriesSwr
 * Standard hook for fetching the list of configured homepage categories.
 * Scoped by dealerId (dlid).
 */
const useHomepageCategoriesSwr = () => {
    const dlid = useDealerId();

    const { data: categories = [], error, isLoading, mutate } = useSWR(
        dlid ? ["homepage_categories", dlid] : null,
        () => HomepageCategoriesService.getAll(dlid).then((res) => res.data)
    );

    return {
        categories,
        error,
        isLoading,
        mutate,
    };
};

export default useHomepageCategoriesSwr;
